/**
 * "Chi lo fa" con i professionisti a parte (28/10/2026).
 *
 * Lorenzo: "devi cambiare anche l'interfaccia normale per me che faccio le task".
 * I professionisti (sviluppatori e altri collaboratori esterni) si assegnano come
 * chiunque, ma è giusto saperlo mentre si sceglie: vedranno la task nella loro
 * area, e solo quella. Prima la squadra, poi i professionisti, con la parola.
 */
import { fullName, type TaskUserLite } from './tasksApi';

export const isProfessionista = (u: Pick<TaskUserLite, 'role'> | null | undefined) => u?.role?.key === 'PROFESSIONISTA';

/** Per le tendine: "Nessuno", la squadra, poi i professionisti in un gruppo loro. */
export function OpzioniPersone({ users, meId }: { users: TaskUserLite[] | undefined; meId?: string }) {
  const tutti = users ?? [];
  const interni = tutti.filter((u) => !isProfessionista(u));
  const esterni = tutti.filter(isProfessionista);
  const opzione = (u: TaskUserLite) => <option key={u.id} value={u.id}>{fullName(u)}{u.id === meId ? ' (io)' : ''}</option>;
  return (
    <>
      <option value="">Nessuno</option>
      {esterni.length > 0 ? <optgroup label="Squadra">{interni.map(opzione)}</optgroup> : interni.map(opzione)}
      {esterni.length > 0 && <optgroup label="Professionisti esterni (vedono solo le loro task)">{esterni.map(opzione)}</optgroup>}
    </>
  );
}

/** Per gli elenchi a scelta (telefono, anteprima): stessa regola, la parola dentro l'etichetta. */
export function scelteDiPersone(users: TaskUserLite[] | undefined, meId?: string): Array<{ v: string; l: string }> {
  const tutti = users ?? [];
  return [...tutti.filter((u) => !isProfessionista(u)), ...tutti.filter(isProfessionista)].map((u) => ({
    v: u.id,
    l: `${fullName(u)}${u.id === meId ? ' (io)' : ''}${isProfessionista(u) ? ' · professionista' : ''}`,
  }));
}
